<template>
  <ul ref="pagination" class="ui-pagination" :style="paginationStyle">
    <li :class="{ disabled: currentPage === 1 }">
      <a @click="changePage(1)">首页</a>
    </li>
    <li :class="{ disabled: currentPage === 1 }">
      <a @click="previousPage">&lt;</a>
    </li>
    <li v-for="page in pages" :key="page" :class="{ active: page === currentPage }">
      <a @click="changePage(page)">{{ page }}</a>
    </li>
    <li :class="{ disabled: currentPage === v_totalPages }">
      <a @click="nextPage">&gt;</a>
    </li>
    <li :class="{ disabled: currentPage === v_totalPages }">
      <a @click="changePage(v_totalPages)">尾页</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'UiPagination',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    totalPages: {
      type: Number,
      default: null,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['mini', 'small', 'medium', 'large'].includes(value);
      },
    },
    position: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'center', 'right'].includes(value);
      },
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    paginationStyle() {
      const fontEnum = {
        mini: '12px',
        small: '13px',
        medium: '14px',
        large: '16px',
      };
      const justifyEnum = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end',
      };
      return {
        justifyContent: justifyEnum[this.position],
        fontSize: fontEnum[this.size],
      };
    },
    v_totalPages() {
      if (this.$props.totalPages) {
        return this.$props.totalPages;
      }
      return Math.ceil(this.total / this.pageSize) || 1;
    },
    pages() {
      let start = Math.max(this.currentPage - 2, 1);
      let end = Math.min(start + 4, this.v_totalPages);
      if (end - start < 4) {
        start = Math.max(end - 4, 1);
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.v_totalPages) {
        this.changePage(this.currentPage + 1);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.changePage(this.currentPage - 1);
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.$emit('input', page);
      this.$emit('change', page);
    },
  },
};
</script>

<style scoped lang="less">
.ui-pagination {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 1em 0;
  padding: 0;

  li {
    margin: 0 0.25em;

    a {
      display: inline-block;
      cursor: pointer;
      padding: 0.5em 1em;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: #f5f5f5;
      color: #333;
      text-decoration: none;
    }

    &.active a, a:hover {
      color: white;
      background-color: #5b2400;
    }
    &.disabled a {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
}
</style>